<script>
import NoResults from '../components/NoResults.vue'
import ListingResource from '../resources/listing'
import CompanyImage from '../components/CompanyImage.vue'
import { mapGetters } from '../store'

export default {
    name: 'SettingsApps',
    components: {
        NoResults,
        CompanyImage
    },
    computed: {
        ...mapGetters(['userResource'])
    },
    data() {
        return {
            loading: false,
            listingResources: [],
            page: null
        }
    },
    methods: {
        
    },
    async mounted() {
        this.loading = true
        this.page = await ListingResource.getUserApplications()
        this.listingResources = this.page.resources

        let attrPromises = []
        
        this.listingResources.forEach((resource) => {
            attrPromises.push(resource.resolveRelated())
            attrPromises.push(resource.resolveAttribute('company.image.source'))
        })

        await Promise.all(attrPromises)

        this.loading = false
    },
}
</script>

<template>
    <div v-page-title="'Applications'">
        <b-row>
            <b-col class="section-heading">
                <h4>Applications</h4>
                <hr />
            </b-col>
        </b-row>

        <div v-if="!loading">
            <div v-if="listingResources.length > 0">
                <b-row v-for="(listingResource, i) in listingResources" :key="i" class="mb-2">
                    <b-col>
                        <company-image :company-resource="listingResource.rel('company').resource" size="3rem" class="float-left mr-3" />
                        <div>
                            <router-link :to="{ name: 'listingsSingle', params: { slug: listingResource.attributes.slug } }"><strong>{{ listingResource }}</strong> at {{ listingResource.get('company.name') }}</router-link>
                        </div>
                        <small>
                            {{ listingResource.get('role.name') }} / {{ listingResource.get('type.name') }}
                        </small>
                        <small class="ml-2" v-if="Number(listingResource.get('compensation_min')) || Number(listingResource.get('compensation_max'))">
                            <b-badge variant="secondary">{{ listingResource.getCompensationPretty() }}</b-badge>
                        </small>
                        <small class="ml-2" v-if="Number(listingResource.get('equity_percentage_min')) || Number(listingResource.get('equity_percentage_max'))">
                            <b-badge variant="secondary">{{ listingResource.getEquityPretty() }}</b-badge>
                        </small>
                    </b-col>
                    <!-- <b-col md="2" class="text-right">
                        <b-button variant="link">Retract</b-button>
                    </b-col> -->
                </b-row>
            </div>
            <no-results v-else>
                <p>Try <router-link :to="{ name: 'home' }">searching for jobs</router-link> to apply to</p>
            </no-results>
        </div>

        <div v-else>
            <b-card>
                <b-skeleton width="85%"></b-skeleton>
                <b-skeleton width="55%"></b-skeleton>
                <b-skeleton width="70%"></b-skeleton>
            </b-card>
            <b-card class="mt-3">
                <b-skeleton width="85%"></b-skeleton>
                <b-skeleton width="55%"></b-skeleton>
                <b-skeleton width="70%"></b-skeleton>
                <b-skeleton width="55%"></b-skeleton>
                <b-skeleton width="70%"></b-skeleton>
                <b-skeleton width="55%"></b-skeleton>
                <b-skeleton width="70%"></b-skeleton>
            </b-card>
        </div>
    </div>
</template>

<style lang="scss"></style>
